import { render, staticRenderFns } from "./App.vue?vue&type=template&id=1c52d4e2&scoped=true&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=1c52d4e2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c52d4e2",
  null
  
)

export default component.exports